export default {
  statistics: {
    total_followers: 'Total urmăritori',
    emails_sent: 'E-mailuri trimise',
    emails_opened: 'E-mailuri deschise',
    emails_clicked: 'E-mailuri accesate',
    emails_average_open_rate: 'Rata de deschidere e-mailuri',
    emails_average_click_rate: 'Rata de accesare e-mailuri',
    push_notifications_sent: 'Notificări push trimise',
    push_notifications_clicked: 'Notificări push accesate',
  },
};
